export interface FormState {
    rate: string;
    transactionType: string;
    category: string;
    class: string;
    glAccountNumber: string;
    chargeLabel: string;
    chargeAmount: string;
    quantity: string;
    total: string;
    memoNote: string;
    predefinedRateId?: string;
}

export const rateNameOptions = [
    { id: 0, name: "Contains" },
    { id: 1, name: "Does not contain" },
    { id: 2, name: "Is equal to" },
    { id: 3, name: "Is not equal to" },
    { id: 4, name: "Starts with" },
    { id: 5, name: "Ends with" },
];

export const defaultCategoryOptions = {
    id: "",
    name: "Select Category",
};

export const defaultClassOptions = {
    id: "",
    name: "Select Class",
};
